
import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";

const AutoFocusError = () => {
    const { errors, submitCount, isSubmitting, setFieldTouched } =
        useFormikContext();
    const prevSubmitCount = useRef(submitCount);

    useEffect(() => {
        if (submitCount > prevSubmitCount.current && !isSubmitting) {
            prevSubmitCount.current = submitCount;

            const firstErrorField = Object.keys(errors)[0];
            if (firstErrorField) {
                setFieldTouched(firstErrorField, true, false);

                requestAnimationFrame(() => {
                    setTimeout(() => {
                        const errorElement = document.querySelector(
                            `[name="${firstErrorField}"]`
                        );
                        if (errorElement) {
                            errorElement.focus();
                        }
                    }, 100);
                });
            }
        }
    }, [submitCount, errors, isSubmitting, setFieldTouched]);

    return null;
};

export default AutoFocusError;
